import React from 'react';
import { Field } from '../../../headless/field';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicTextAreaProps } from '../../../types/public-props';

interface InputTextAreaProps {
  className?: string;
}

export const Input = React.forwardRef<HTMLDivElement, InputTextAreaProps>(
  (props, ref) => {
    const { className } = props;

    const { value, onChange, onBlur } = useFieldProps<PublicTextAreaProps>();

    return (
      <Field.Input ref={ref}>
        <textarea
          className={className}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
        >
          {value}
        </textarea>
      </Field.Input>
    );
  },
);

Input.displayName = 'TextArea.Input';
